import {
  CheckCircleOutlined,
  CloseCircleOutlined,
  ExclamationCircleOutlined,
} from "@ant-design/icons";

let notificationApi = null;

export const initNotification = (api) => {
  notificationApi = api;
};

export const SuccessToast = (message, description) => {
  notificationApi?.success({
    message,
    description,
    icon: <CheckCircleOutlined style={{ color: "green" }} />,
  });
};

export const ErrorToast = (message, description) => {
  notificationApi?.error({
    message,
    description,
    icon: <CloseCircleOutlined style={{ color: "red" }} />,
  });
};

export const WarningToast = (message, description) => {
  notificationApi?.warning({
    message,
    description,
    icon: <ExclamationCircleOutlined style={{ color: "#F96E2A" }} />,
  });
};
